import React from 'react';
import { Folder as FolderIcon } from 'lucide-react';
import type { Folder } from '../../../types';

type Props = {
  items: Folder[];
  selectedId?: string | null;
  onSelect: (id: string) => void;
  height?: number;
  itemSize?: number;
};

export const FolderListVirtualized: React.FC<Props> = React.memo(
  ({ items, selectedId, onSelect }) => {
    const renderItem = React.useCallback(
      (f: Folder) => {
        const isSelected = selectedId === f.id;
        return (
          <li key={f.id}>
            <button
              type="button"
              className={`flex w-full items-center gap-3 px-3 py-2 text-left hover:bg-slate-50 ${
                isSelected ? 'bg-blue-50' : ''
              }`}
              onClick={() => onSelect(f.id)}
            >
              <span
                className={`mt-[1px] inline-block h-4 w-4 shrink-0 rounded-full border ${
                  isSelected ? 'border-blue-600 bg-blue-600' : 'border-slate-300'
                }`}
                aria-hidden
              />
              <FolderIcon className="h-5 w-5 shrink-0 fill-amber-200 text-amber-400" />
              <span className="truncate">{f.name}</span>
            </button>
          </li>
        );
      },
      [onSelect, selectedId]
    );

    return (
      <ul className="max-h-72 overflow-auto rounded border">{items.map((f) => renderItem(f))}</ul>
    );
  }
);

export default FolderListVirtualized;
